import { MicNone } from "@mui/icons-material";
import { IconButton } from "@mui/material";
import React, { useEffect, useState } from "react";
import "./Chat.css";
import Message from "./Message";
import { useSelector } from "react-redux";
import { selectchatId, selectchatName } from "../../features/chatSlice";
import firestoreDB from "../../config/firebase";
import { selectUser } from "../../features/userSlice";
import FlipMove from "react-flip-move";

function Chat() {
  const [input, setInput] = useState("");
  const chatName = useSelector(selectchatName);
  const chatId = useSelector(selectchatId);
  const user = useSelector(selectUser);
  const [messages, setMessages] = useState([]);

  useEffect(() => {
    if (chatId) {
      firestoreDB
        .collection("Chats")
        .doc(chatId)
        .collection("messages")
        .orderBy("date", "asc")
        .onSnapshot((snapshot) =>
          setMessages(
            snapshot.docs.map((doc) => ({
              id: doc.id,
              data: doc.data(),
            }))
          )
        );
    }
  }, [chatId]);

  console.log(messages);
  const sendMsg = (e) => {
    e.preventDefault();
    firestoreDB.collection("Chats").doc(chatId).collection("messages").add({
      msg: input,
      uid: user.uid,
      photo: user.photo,
      date: new Date(),
    });
    setInput("");
  };
  return (
    <div className="chat">
      <div className="chat__header">
        <h4>
          To: <span>{chatName}</span>
        </h4>
        <strong>Details</strong>
      </div>
      <div className="chat__body">
        <FlipMove>
          {messages.map(({ id, data }) => (
            <Message key={id} content={data} />
          ))}
        </FlipMove>
      </div>
      <div className="chat__input">
        <form>
          <input
            value={input}
            onChange={(e) => setInput(e.target.value)}
            placeholder="iMessage"
            type="text"
          />
          <button onClick={sendMsg}>Send Msg</button>
        </form>
        <IconButton>
          <MicNone />
        </IconButton>
      </div>
    </div>
  );
}

export default Chat;
